import { reactify } from '@zeiss/zui-react';
export const ZuiIconMedReferToCornealVertex = reactify('zui-icon-med-refer-to-corneal-vertex');
